import { Component } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { ModalController } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { WideLayoutComponent } from '@examdojo/layout';

@Component({
  selector: 'dojo-leave-confirmation-dialog',
  template: `
    <div class="flex flex-col p-6">
      <div class="aligner mx-auto mb-4 mt-2 h-[135px] w-[135px] p-3">
        <img src="assets/images/challenge/timing.svg" alt="" />
      </div>
      <h3 class="text-display-xs text-primary mb-2 text-center font-semibold">
        {{ 'challenge_leave_popup.title' | transloco }}
      </h3>
      <p class="text-secondary text-md mb-9 text-center">
        {{ 'challenge_leave_popup.warning' | transloco }}
      </p>
      <div class="flex flex-col gap-3">
        <dojo-button (click)="leave()">
          {{ 'challenge_leave_popup.leave' | transloco }}
        </dojo-button>
        <wide-layout>
          <dojo-button (click)="stay()" [fill]="'outline'" [customColor]="'sky'">
            {{ 'challenge_leave_popup.stay' | transloco }}
          </dojo-button>
        </wide-layout>
      </div>
    </div>
  `,
  styles: [
    `
      ::ng-deep ion-modal.leave-confirmation-dialog {
        @media only screen and (min-width: 768px) {
          --width: 480px;
        }
      }
    `,
  ],
  imports: [ButtonComponent, TranslocoPipe, WideLayoutComponent],
})
export class LeaveConfirmationDialogComponent {
  constructor(private readonly modalController: ModalController) {}

  stay() {
    this.modalController.dismiss(false);
  }

  leave() {
    this.modalController.dismiss(true);
  }
}
